import { render, staticRenderFns } from "./JobFamilyIcon.vue?vue&type=template&id=b8ba6872"
import script from "./JobFamilyIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./JobFamilyIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports